import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={17.921}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 8807 12631"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#231f20}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="XMLID_67_">
        <path
          id="XMLID_68_"
          d="M6891 0H5769c38 1027 213 4896 755 6666 2042-54 2283-178 2283-178C7093 3799 6891 0 6891 0z"
          className="fil0"
        />
        <path
          id="XMLID_93_"
          d="M1916 0S1714 3799 0 6488c0 0 240 123 2263 177 541-1770 716-5638 754-6665H1916z"
          className="fil0"
        />
        <path
          id="XMLID_100_"
          d="M4672 11518v-796c663-187 1150-1053 1150-2126 0-836-296-1547-741-1909 466-2 876-8 1233-16-544-1842-711-5652-747-6671H3219c-36 1019-203 4828-747 6670 363 8 779 14 1254 17-444 362-740 1073-740 1909 0 1073 487 1939 1149 2126v796c-531-3-1698 58-1698 660v453h3912v-453c1-594-1137-662-1677-660zm0-4567c401 212 702 879 702 1645s-301 1433-702 1645V6951zM3434 8596c0-766 301-1433 701-1645v3290c-400-212-701-879-701-1645z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
